import { render, staticRenderFns } from "./editProductCategory.vue?vue&type=template&id=e06ec72a"
import script from "./editProductCategory.vue?vue&type=script&lang=js"
export * from "./editProductCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports